export enum GettingStartedSteps {
    LoanPurpose = 'LP',
    HomebuyingStatus = 'HS',
    RefinanceGoals = 'RG'
}